"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  deliveryInfo: {
    title: '换单时间及费用查询',
    baseInfo: '提单信息',
    blNo: '提单号',
    containerNo: '箱号',
    vessel: '航名航次',
    eta: '预计到港时间',
    deliverableDate: '可换单时间',
    feeInfo: '费用信息',
    containerQuantity: '箱量',
    rate: '费率',
    total: '总计（不包含OF）',
    chargeCode: '费用类型',
    containerType: '箱型',
    amount: '$费用',
    tips_1: '温馨提示：',
    tips_2: '（1） 进口可换单时间、费用信息仅供参考，实际以邮件和传真等书面通知为准。'
  }
};